@use '../@shared/global' as *;
@use '../@shared/alert.mixin' as *;
@use '../@shared/button.mixin' as *;
@use '../@shared/popover-button.mixin' as *;
@use '../@shared/table-stateless.mixin' as *;
@use '../@shared/mixins' as *;
@use '../host-display-block' as *;
@use '../tooltip/style' as *;

@layer kol-component {
	@include kol-alert;
	@include kol-button-styles('kol-button');
	@include kol-popover-button-styles;
	@include kol-table-stateless-styles;
}
